// import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';

// import { TitleRow } from 'components/styledComponents';
// import { StyledTitle } from 'components/StyledTitle';
import { Markdown } from 'components';

export const DeclarationStatement = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      {/* <TitleRow align="middle" justify="space-between"> */}
      <Row align="middle" justify="space-between">
        <Col>
          {/* <StyledTitle color="var(--text-color-secondary)" level={3}> */}
          <h3>{t('cms.declaration.document.banner.heading')}</h3>
          {/* </StyledTitle> */}
        </Col>
        {/* </TitleRow> */}
      </Row>
      <Markdown>{t('cms.declaration.document.content')}</Markdown>
    </>
  );
};
